// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"09ec7949","668":"face2c5a"}[chunkId] + ".chunk.js";
};